import { FC } from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

const RobotExceptionPage: FC = () => {
  return (
    <Wrapper>
      <div className={'top-content-header'}>
        <img src='https://static.findmyupgrade.com/website/404-page.png' alt='Fritz' />
        <div className={'top-content-header-info'}>
          <h1>Something went wrong.</h1>
          <h3>
            The page you requested was not found. Please try again or contact support at{' '}
            <Link to='tel:+18008010018'>1-800-801-0018</Link>.
          </h3>
        </div>
      </div>
    </Wrapper>
  );
};

export default RobotExceptionPage;

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .top-content-header {
    font-size: 38px;
    padding: 0 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 10px 0;
    font-family: inherit;
    font-weight: 600;
    line-height: 20px;
    text-rendering: optimizelegibility;
  }

  h1,
  h2,
  h3 {
    line-height: 1.3;
  }
  h1 {
    font-size: 30px;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
  }
  h3 {
    font-size: 16px;
    font-weight: 300;
  }

  .top-content-header-info {
    font-size: 38px;
    padding: 30px 35px;
    max-width: 800px;
  }
`;
